module.exports = __webpack_public_path__ + "static/media/ic-conte-do.b9d2cffc.svg";